import { isoZ, z } from 'my-zod'

export const discountUnitOptions = [
  'fixedAmountOffTotal',
  // 'fixedAmountOffEach',
  'percentOffEach',
  'percentOffSingle'
] as const

export const discountModel = z.object({
  id: z.string(),
  shortId: z.string(),
  customerOrderId: z.string(),
  type: z.enum(['AdHoc', 'Promotion']),
  providedBy: z.enum(['Polaris', 'Outfitter']),
  notes: z.string().max(255),
  promotionId: z.string().nullable(),
  promotionVersionId: z.number().nullable(),
  amount: z.number(),
  unit: z.enum(discountUnitOptions),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type discountModel = z.infer<typeof discountModel>
